"use client";

import {
  useAutumnContext
} from "./chunk-EOSHPHLH.mjs";

// src/libraries/react/hooks/useCustomerBase.tsx
import useSWR from "swr";
var useCustomerBase = ({
  params,
  AutumnContext,
  client
}) => {
  const queryKey = ["customer"];
  let context;
  if (AutumnContext) {
    context = useAutumnContext({ AutumnContext, name: "useCustomer" });
  }
  if (!client) {
    client = context.client;
  }
  const fetchCustomer = async () => {
    const { data: data2, error: error2 } = await client.createCustomer({
      errorOnNotFound: params?.errorOnNotFound,
      expand: params?.expand
    });
    if (error2) {
      throw error2;
    }
    if (!data2) {
      return null;
    }
    return data2;
  };
  const { data, error, isLoading, mutate } = useSWR(queryKey, fetchCustomer, {
    fallbackData: null,
    onErrorRetry: (error2, key, config) => {
      if (error2.code == "entity_not_found") {
        return false;
      }
      return true;
    }
  });
  return {
    customer: error ? null : data,
    isLoading,
    error,
    refetch: mutate,
    createEntity: client.entities.create,
    createReferralCode: client.referrals.createCode,
    redeemReferralCode: client.referrals.redeemCode
  };
};

export {
  useCustomerBase
};
